import Swiper from 'swiper/bundle';

export const patternBooks = () => {
  $('.scrolling-books')
    .removeClass('wp-block-gallery')
    .addClass('swiper')
    .children()
    .addClass('swiper-slide')
    .wrapAll('<div class="swiper-wrapper">');

  const swiper = new Swiper('.scrolling-books', {
    // Optional parameters
    spaceBetween: 40,
    centeredSlides: true,
    speed: 5000,
    autoplay: {
      delay: 0,
    },
    freeMode: true,
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: false,
  });
};
